export const reportDictionary = (type, value) => {
  const dictionaries = {
    individual: {
      hurlingham: 'introspection',
      natura: 'professional',
      integrado: 'integrator',
      default: 'default',
      defaultSupervision: 'defaultSupervision',
      clevel: 'clevel',
      tecnico: 'technical',
      mandosMedios: 'mandosMedios',
      exit: 'exit',
      islasBaleares: 'islasBaleares',
      Comfama: 'extended',
      vocacional: 'orientation',
    },
    company: {
      Comfama: 'extended',
      vocacional: 'orientation',
      tecnico: 'technical',
      clevel: 'clevel',
      mandosMedios: 'mandosMedios',
      exit: 'exit',
      default: 'defaultSupervision',
      defaultSupervision: 'defaultSupervision',
    },
  };

  const dictionary = dictionaries[type] || dictionaries['individual'];

  if (type === 'company' && (!value || value === 'default')) {
    return 'defaultSupervision';
  }

  return (
    dictionary[value] ||
    dictionaries['individual'][value] ||
    dictionaries['individual']['default']
  );
};
